const SEP = '|';

/**
 * Dealer city autocomplete stores a composite key in the `city` form field so the control value
 * stays unique when multiple places share the same city name. This returns the plain city name for APIs.
 *
 * @param formValue - Either `city|stateAbbr|region` from the picker, or a legacy plain city string.
 */
export function citySelectionKeyToApiCityName(formValue: string | null | undefined): string {
    const v = String(formValue ?? '').trim();
    if (!v) return '';
    if (!v.includes(SEP)) return v;
    return v.split(SEP)[0]?.trim() ?? '';
}
